import { useState, useEffect } from "react";

const COOKIE_KEY = "fv_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
    window.dispatchEvent(new Event("cookie-consent-changed"));
  };

  const reject = () => {
    localStorage.setItem(COOKIE_KEY, "rejected");
    setVisible(false);
    window.dispatchEvent(new Event("cookie-consent-changed"));
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up" data-testid="cookie-banner">
      <div className="max-w-5xl mx-auto px-4 pb-4">
        <div className="bg-slate-900 rounded-2xl p-5 sm:p-6 shadow-2xl border border-slate-800 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex-1 min-w-0">
            <p className="text-sm text-slate-200 font-medium mb-1" style={{ fontFamily: "Outfit, sans-serif" }}>
              Informativa sui Cookie
            </p>
            <p className="text-xs text-slate-400 leading-relaxed">
              Utilizziamo cookie tecnici e, previo tuo consenso, cookie di profilazione per migliorare la tua esperienza e per finalita di marketing.
              Puoi accettare o rifiutare i cookie non essenziali. <a href="/privacy" className="underline text-emerald-400 hover:text-emerald-300 transition-colors">Privacy Policy</a>
            </p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <button
              onClick={reject}
              className="text-xs font-semibold text-slate-400 hover:text-white border border-slate-700 hover:border-slate-500 rounded-full px-5 py-2.5 transition-colors"
              data-testid="cookie-reject-btn"
            >
              Rifiuta
            </button>
            <button
              onClick={accept}
              className="text-xs font-bold text-white bg-emerald-500 hover:bg-emerald-600 rounded-full px-5 py-2.5 transition-colors shadow-lg shadow-emerald-500/20"
              data-testid="cookie-accept-btn"
            >
              Accetta tutti
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export function hasCookieConsent() {
  return localStorage.getItem(COOKIE_KEY) === "accepted";
}
